export default "__VITE_ASSET__18832169__"